/**
 * Direction agreement between a bank transaction and an invoice.
 *
 * Sign convention (matches TransactionsPage colouring): a positive transaction
 * amount is money IN (a credit), a negative amount is money OUT (a debit).
 * An incoming credit should settle a receivable (outbound) invoice; an
 * outgoing debit should settle a payable (inbound) invoice. When they disagree
 * the pairing is suspicious (though credit notes legitimately invert, which is
 * why this is a surfaced warning, not a hard block or a scoring change).
 *
 * Pure sign comparison: no Math.abs, no magnitude, no currency conversion.
 */
export function directionMismatch(txAmount, invoiceType) {
  if (txAmount == null || txAmount === 0 || !invoiceType) return false;
  const t = String(invoiceType).toLowerCase();
  const isReceivable = t === 'outbound' || t === 'receivable';
  const isPayable = t === 'inbound' || t === 'payable';
  if (txAmount > 0 && isPayable) return true;
  if (txAmount < 0 && isReceivable) return true;
  return false;
}
